(function () {
  'use strict';

  /* @ngdoc object
   * @name trackingDiscrepancy
   * @description
   *
   */
  angular
    .module('trackingDiscrepancy', [
      'ui.router'
    ]);
}());
